import { Building2, RadioTower, Smile } from 'lucide-react';

// バックエンドのHubTypeCd(1=spot,2=festa,3=stand,4=studio,5=schoomyers,6=crew,7=stage,8=in)のうち
// フロントにUIバリエーションがあり「使用可能」として扱うのはspot/stage/schoomyersの3種のみ。
export const HUB_AFFILIATION = {
    spot: { label: 'spot', Icon: RadioTower, color: '#FF3626' },
    stage: { label: 'stage', Icon: Building2, color: '#FFC400' },
    schoomyers: { label: 'schoomyers', Icon: Smile, color: '#00B8E6' },
} as const;

// それ以外(festa/stand/studio/crew/in)、およびhub_id自体が無い(未所属)場合はfalseを返す。
// isBoardConnectedの算出等で使用不可扱いにするための判定に使う。
export function isUsableHubType(hubTypeCd: string | null | undefined): boolean {
    return hubTypeCd === '1' || hubTypeCd === '5' || hubTypeCd === '7';
}

export function hubTypeCdToAffiliation(hubTypeCd: string | null | undefined): keyof typeof HUB_AFFILIATION | null {
    switch (hubTypeCd) {
        case '1':
            return 'spot';
        case '7':
            return 'stage';
        case '5':
            return 'schoomyers';
        default:
            return null;
    }
}
